import React from 'react';
import { ComingSoonPage } from '@/shared/components/ComingSoonPage';
import { View } from '../../types';
import { APP_REGISTRY, CyzorAppId } from '../../core/navigation/appRegistry';

interface ComingSoonAppRouterProps {
  currentView: View | 'admin';
  appId: CyzorAppId;
}

export function ComingSoonAppRouter({ appId }: ComingSoonAppRouterProps) {
  const manifest = APP_REGISTRY[appId];
  if (!manifest) {
    return (
      <div className="p-8 text-center text-slate-500">App não encontrado.</div>
    );
  }
  return <ComingSoonPage manifest={manifest} />;
}

export default ComingSoonAppRouter;
